import { TagPropExcludes } from 'apprise-core/tag'
import { createProvider } from 'apprise-frontend-core/state/factory'
import { FormExcludes } from 'apprise-frontend-core/utils/formexcludes'
import { noModule } from 'apprise-frontend-tags/constants'
import { ExternalClientCache, TagClientCache, TagCloneProvider, TagExcludesProvider } from 'apprise-frontend-tags/tag/context'
import { PropsWithChildren } from "react"






export type TagProviderProps = PropsWithChildren<Partial<{

    formExcludes: FormExcludes<TagPropExcludes>

}>>


// since (01/26): keep registries inlined so that it resets when this is remounted on HMR.
// if it didn't, then app initialisers would register multiple times with various forms of errors.

export const [TagModuleProvider, useRegisteredModules] = createProvider({

    all: [noModule],

})

export const TagProvider = (props: TagProviderProps) => {

    const { children, formExcludes } = props

    return <ExternalClientCache>
        <TagClientCache>
            <TagModuleProvider>
                <TagCloneProvider>
                    <TagExcludesProvider {...formExcludes} >
                        {children}
                    </TagExcludesProvider>
                </TagCloneProvider>
            </TagModuleProvider>
        </TagClientCache>
    </ExternalClientCache>
}